<template>
    <b-modal id="product_delete" ref="product_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.product.data.attributes.name + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('product_delete')" v-text="'Cancel'"/>

            <state-button size="sm" :click="deleteProduct">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ProductDeleteModal",

        components: {
            StateButton,
        },

        props: [
          'product'
        ],

        methods: {
            hideModal(refname) {
                this.$refs[refname].hide();
            },

            deleteProduct() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteProduct', this.product)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-product');

                                this.$notify('error filled', 'Success!', 'Deleted the product!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
        }

    }
</script>

<style scoped>

</style>
